/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NumberCircle04Icon16Light } from './NumberCircle04Icon16Light';
import { NumberCircle04Icon16Regular } from './NumberCircle04Icon16Regular';
import { NumberCircle04Icon16Solid } from './NumberCircle04Icon16Solid';
import { NumberCircle04Icon20Light } from './NumberCircle04Icon20Light';
import { NumberCircle04Icon20Regular } from './NumberCircle04Icon20Regular';
import { NumberCircle04Icon20Solid } from './NumberCircle04Icon20Solid';
import { NumberCircle04Icon24Regular } from './NumberCircle04Icon24Regular';
import { NumberCircle04Icon24Solid } from './NumberCircle04Icon24Solid';
import { NumberCircle04Icon32Regular } from './NumberCircle04Icon32Regular';
import { NumberCircle04Icon64Regular } from './NumberCircle04Icon64Regular';
var sizes = {
    16: {
        light: NumberCircle04Icon16Light,
        regular: NumberCircle04Icon16Regular,
        solid: NumberCircle04Icon16Solid,
    },
    20: {
        light: NumberCircle04Icon20Light,
        regular: NumberCircle04Icon20Regular,
        solid: NumberCircle04Icon20Solid,
    },
    24: {
        regular: NumberCircle04Icon24Regular,
        solid: NumberCircle04Icon24Solid,
    },
    32: {
        regular: NumberCircle04Icon32Regular,
    },
    64: {
        regular: NumberCircle04Icon64Regular,
    },
};
export var NumberCircle04Icon = forwardRef('NumberCircle04Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
